import React from 'react';
import { Checkbox } from './Checkbox';

export const renderCheckbox = ({
  input,
  meta: { touched, error },
  handleChange,
  children,
  checked,
  colorActive
}) => (
    <Checkbox
      {...input}
      name={input.name}
      handleChangeInput = {input.onChange}
      handleChange={handleChange}
      handleBlur={input.onBlur}
      error={touched && error}
      checked={checked}
      children={children}
      colorActive={colorActive}
    />
);
